import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background:#005C53;
`;

export const Form = styled.form`
  width: 400px;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  img {
    width: 200px;
    margin: 10px 0 40px;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  p {
    color: #ff3333;
    margin-bottom: 15px;
    border: 1px solid #ff3333;
    padding: 10px;
    width: 100%;
    text-align: center;
  }
  input {
    flex: 1;
    height: 46px;
    margin-bottom: 20px;
    padding: 20px;
    color: #005C53;
    font-size: 15px;
    width: 100%;
    border: 2px solid #ddd;
    border-radius: 4px;
    transition: border-color 0.3s, outline-color 0.3s;
    &::placeholder {
      color: #005C53;
      border-radius: 5px;
    }
    &:focus {
      border-color: #005C53;
      outline: 1.5px solid #005C53;
      outline-offset: 0px;
      box-shadow: 0 0 0 2px #005C5340; // leve brilho suave
    }
  }
  button {
    color: #fff;
    font-size: 16px;
    background: #005C53;
    height: 56px;
    border: 0;
    border-radius: 10px;
    width: 100%;
  }
  hr {
    margin: 20px 0;
    border: none;
    border-bottom: 1px solid #cdcdcd;
    width: 100%;
  }
  a {
    font-size: 16px;
    font-weight: bold;
    color: #999;
    text-decoration: none;
    display: block;
    text-align: center;
    margin-top: 10px;
  }
  h4 {
    text-align: center;
    font-size: 1.2rem; // diminui o tamanho da fonte
    font-weight: 600;
    color: #005C53;
    margin-bottom: 24px;
    margin-top: 8px;
    letter-spacing: 1px;
  }
`;
